module.exports = __webpack_public_path__ + "static/media/availability_settings1.43541e8a.png";